export async function LoadPicksData(userID) {
  try {
    const url = `/returnPicks/${userID}`;

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    const data = await response.json();

    return { data };
  } catch (error) {
    throw error;
  }
}
